// icons
import * as MdIcons from "react-icons/md";
import {translate} from "../../../../utils/Common"


const ItemPaymentMethod = ({ paymentMethod, deleteMethod }) => {
    return (
        <div className="mb-3 w-12/12 md:w-12/12 border-bottom flex flex-row pb-2 mb-1" >
            <div className="paymentMethod-name">
                <label className="mb-0" htmlFor="inputFormaPago">{translate("global.paymentMethod")}:</label>
                <input type="text" value={ paymentMethod?.name ? paymentMethod.name : '' } readOnly className="h-9 text-sm text-sm h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-semibold"/>
            </div>
            <div className="paymentMethod-amount ml-2">
                <label className="mb-0" htmlFor="inputMonto">{translate("global.amountPayment")}</label>
                <input type="text" value={ paymentMethod?.amount >= 0 ? (`$ ${paymentMethod.amount}`) : '' } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold"/>
            </div>
            { paymentMethod.id !== 5 &&
                <div className="packageForPickup flex flex-col"> 
                    <label className="mb-0" htmlFor="delete-btn">{translate("global.delete")}</label>
                    <MdIcons.MdRemoveCircle size={22} className="mt-1" id="delete-btn" onClick={ () => deleteMethod(paymentMethod.id) } />
                </div>
            }
        </div>
    );
}

export default ItemPaymentMethod;